import { createContext, type ReactNode } from 'react';

import { DEFAULT_CUSTOM_TOOLTIP_CONFIG } from '../../core/constants.js';
import type { ChartTooltipConfig } from '../../core/types/tooltip.js';
import type { _XYChartTooltipVariant } from '../types/xy-chart-props.js';
import { XYChartTooltipPayload } from '../types/xy-chart.js';

export interface XYChartTooltipConfig extends ChartTooltipConfig {
  template?: (tooltipPayload: XYChartTooltipPayload) => ReactNode;
  variant: _XYChartTooltipVariant;
}

export { DEFAULT_CUSTOM_TOOLTIP_CONFIG };

export const XYChartTooltipContext = createContext<XYChartTooltipConfig>({
  ...DEFAULT_CUSTOM_TOOLTIP_CONFIG,
  variant: 'single',
});
